export default __webpack_public_path__ + "static/media/BootsSharp-Regular1.e7dd9e2c.ttf";